import PropTypes from 'prop-types'
import { Fragment } from 'react'

import VisualizationWelcomeBanner from 'components/VisualizationWelcomeBanner'
import useAgent from 'hooks/use-agent'
import useAuth from 'hooks/use-auth'
import useClientResource from 'hooks/use-client-resource'
import theme from 'theme'

import InstallBanner from '../notification-banners/InstallBanner'
import ProfileSection from './ProfileSection'
import TeamSection from './TeamSection'

const TopBanner = ({ hasMetricsDisabled, ...rest }) => {
  const { isFreeEdition } = useAuth()
  const { hasClients, infraIsLoading, alfiIsLoading } = useClientResource()

  if (infraIsLoading || alfiIsLoading) return null

  return (
    <div
      css={{
        marginBottom: theme.space[1]
      }}
      {...rest}
    >
      {!hasClients && <InstallBanner showSubheader />}

      {!isFreeEdition && hasClients && hasMetricsDisabled && (
        <VisualizationWelcomeBanner css={{ marginTop: theme.space[3] }} />
      )}
    </div>
  )
}

TopBanner.propTypes = {
  hasMetricsDisabled: PropTypes.bool
}

const DashboardHeader = () => {
  const { companyId, currentTeamId } = useAuth()

  // TODO: Both URLs must be present for the integration test example_spec.js to pass.  Unsure why this behaves that way, needs to be resolved.
  const {
    data: [[company]],
    isLoading,
    doFetch
  } = useAgent(
    [`/companies/${companyId}`, `/users?teamId=${currentTeamId}`],
    // company endpoint returns array of 1
    [[{ orgs: [] }], {}],
    { shouldCache: true }
  )

  return (
    <Fragment>
      <div
        data-test-dashboard-header
        css={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          marginBottom: 0
        }}
      >
        <ProfileSection company={company} />
        <TeamSection
          company={company}
          doFetch={doFetch}
          isLoading={isLoading}
        />
      </div>

      <TopBanner
        hasMetricsDisabled={
          !company.prefs?.monitoring?.opt_in?.value && !isLoading
        }
      />
    </Fragment>
  )
}

export default DashboardHeader
